module.exports = __webpack_public_path__ + "img/image_109.f11b6126.png";